export default {
  allStates: 'All states',
  zeroStates: '0 states are selected',
};
